import { AnalyticsUser } from '../../interfaces/analyticsUser';

/*
 * Private helper functions
 */

const toString = (content: number | string) =>
  content && content !== '0' ? String(content) : '';

const toFeatureFlagsString = (
  flags: { featureName: string; isActive: boolean }[],
) => {
  if (!flags) return '';

  let values = '';

  flags.forEach((item) => {
    values += item.featureName + '|' + item.isActive + ',';
  });

  return values;
};

const build = ({ userId, userFeatures } = {} as AnalyticsUser) => {
  const user = {
    client: {
      id: '',
      language: 'th-TH',
    },
    login: {
      id: toString(userId),
      type: 'Email',
      status: userId ? 'logged-in' : 'logged-out',
    },
    features: toFeatureFlagsString(userFeatures),
  };
  return { user };
};

export default {
  build,
  toFeatureFlagsString,
};
